import { Directive, inject, TemplateRef } from "@angular/core";

@Directive({
  standalone: true,
  selector: '[appSideMenuTabLabel]'
})
export class SideMenuTabLabel {
  // eslint-disable-next-line @tseslint/no-explicit-any
  public template: TemplateRef<any> = inject(TemplateRef<any>);
}
